import { useLocation } from 'react-router-dom';

import { CopilotDrawer } from '@/components/CopilotDrawer';
import { PageLayout } from '@/components/PageLayout';
import { useDbtCloudAccount } from '@/context/DbtCloudProvider';
import { useFeatureFlags } from '@/context/FeatureFlagProvider';
import { useQueryParamOption } from '@/hooks/queryParamOption';
import { SearchHeader } from '@/pages/account/components/SearchHeader';
import { getViewType } from '@/pages/account/NewMultiProjectPage';
import { ViewType, viewTypes } from '@/util/linkTypes';
import { AccountNavigationTree } from './AccountNavigationTree/AccountNavigationTree';

export const MultiProjectNavPanel = () => {
  const { ai447CatalogAgenticChat } = useFeatureFlags();
  const { accountId, hasAccountFeature, account } = useDbtCloudAccount();
  const isCatalogPreviewEnabled = hasAccountFeature('explorerAccountUI');

  const [_viewParam] = useQueryParamOption({
    param: 'view',
    options: viewTypes,
    validateOption: getViewType,
  });
  const viewParam: ViewType = _viewParam ?? 'list';
  const path = useLocation().pathname;

  const isLineage = path.endsWith('lineage/');

  if (!accountId) {
    return <>Invalid account ID</>;
  }
  return (
    <PageLayout
      isLoading={!account}
      header={() => {
        return <SearchHeader shouldUseTypeahead={true} />;
      }}
      showBanner={isCatalogPreviewEnabled}
      className="md:p-4"
    >
      {isCatalogPreviewEnabled && viewParam !== 'lineage' && !isLineage && (
        <>
          <div className="flex h-full w-full flex-col">
            <div className="min-h-0 flex-1">
              <AccountNavigationTree />
            </div>
          </div>
          {ai447CatalogAgenticChat && <CopilotDrawer />}
        </>
      )}
    </PageLayout>
  );
};
